import { PagedResult } from "../../types/apis"
import { WorkawareApi } from '../../apis/WorkawareApi'
import { SMSLogModel } from '../models/SMSLogModel'

export class smsLogService {
    private _api: WorkawareApi
    constructor(api: WorkawareApi) {
        this._api = api
    }

    // get = (page: number, rowsPerPage: number) => {
    //     return new Promise<PagedResult<SMSLogModel>>((resolve, reject) => {
    //         this._api.smsLog.get(page, rowsPerPage)
    //             .then(result => resolve({
    //                 Count: result["Count"] as number,
    //                 Values: result.Values
    //             }))
    //             .catch(error => reject(error))
    //     })
    // }
get = (page: number, rowsPerPage: number, userId?: number) => {
    return new Promise<PagedResult<SMSLogModel>>((resolve, reject) => {
        this._api.smsLog.get(page, rowsPerPage)
            .then(result => {
                let filteredValues = result.Values.filter((item: any) =>
                    item.CreatedName !== null && item.CreatedName !== undefined
                )
                if (userId) {
                    filteredValues = filteredValues.filter((item: any) =>
                        item.CreatedByUserId === userId || item.ToUserId === userId
                    )
                }
                resolve({
                    Count: filteredValues.length,
                    Values: filteredValues
                })
            })
            .catch(error => reject(error))
    })
}

    delete = (id: number) => {
        return new Promise<any>((resolve, reject) => {
            this._api.smsLog.delete(id)
                .then(result => resolve(result))
                .catch(error => reject(error))
        })
    }
}